export default __webpack_public_path__ + "static/media/webird-mobile.87220df3.jpg";